import { Typography } from "@datamole/wds-component-typography";

import { Button } from "@/components/ui/button";
import { Dialog } from "@/components/ui/dialog";
import { CheckIcon } from "@/components/ui/icon";
import { Spinner } from "@/components/ui/spinner";
import { DISPLAY_DATE_FORMAT } from "@/constants";
import styles from "@/guards/user-consent-guard/user-consent-guard.module.css";
import { dayjs } from "@/utils/dayjs";

interface Props {
    onAcceptConsent: () => void;
    isAcceptConsentLoading: boolean;
}

export const UserConsentGuardDialog = ({ onAcceptConsent, isAcceptConsentLoading }: Props) => {
    const consentExpirationDate = dayjs().add(1, "year").format(DISPLAY_DATE_FORMAT);

    return (
        <Dialog open={true}>
            <Dialog.Content>
                {/**
                 * Workaround to discard radix UI accessibility error.
                 * TODO: Update WDS Dialog component so the close button can be omitted.
                 */}
                <Dialog.Content.Header hidden />

                <div className={styles.header}>Content Use Statement</div>
                <Dialog.Content.Body>
                    <div className={styles.element_dialog_body}>
                        <Typography>
                            The information generated using ARDI is considered as Confidential to FRDC. Do not share any
                            information generated in ARDI beyond FRDC. If you need to use the generated content in
                            communication or reports beyond FRDC, please contact your Line Manager.
                        </Typography>
                        <Typography>
                            Note: This statement will need to be accepted annually on {consentExpirationDate}.
                        </Typography>
                    </div>
                </Dialog.Content.Body>
                <Dialog.Content.Actions>
                    <Button
                        variant="primary"
                        onClick={onAcceptConsent}
                        disabled={isAcceptConsentLoading}
                        startIcon={isAcceptConsentLoading ? <Spinner size="xs" /> : <CheckIcon />}
                    >
                        I acknowledge this statement
                    </Button>
                </Dialog.Content.Actions>
            </Dialog.Content>
        </Dialog>
    );
};
